//package imports
import { toJS } from "mobx"

// project imports
import OptimizationStore from "modules/optimization/store/OptimizationStore"
import * as APITypes from "constants/API"
import axios from "utils/axios"

export const fetchCashFlowTableData = async (productData) => {

  OptimizationStore.showMainLoading = true
  let reqObj = {
    "family_product_id": productData.data.family_product_id,
    "product_id": productData.data.product_id,
    "package_id": productData.data.package_id,
    "product_name": productData.data.product_name,
    "quotation_id": productData.data.quotationId
  }

  try {
    const response = await axios.post(APITypes.FETCH_PRODUCT_TIME_LINE_BY_QUOTATION, reqObj)
    OptimizationStore.showMainLoading = false
    return response
  } catch (error) {
    console.log(error)
    OptimizationStore.showMainLoading = false
  }

}